import { useTranslation } from '@packlink/translation-provider';
import { Dialog, DialogHeader, DialogContent } from '@shipengine/giger';
import { getServiceCardDialogHeaderStyles, getServiceCardDialogContentStyles } from './ServiceCardDialogStyles.js';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';

let ServiceCardDialogType = /*#__PURE__*/function (ServiceCardDialogType) {
  ServiceCardDialogType["DETAILS"] = "details";
  ServiceCardDialogType["DROPOFF"] = "dropoff";
  return ServiceCardDialogType;
}({});
const ServiceCardDialog = _ref => {
  let {
    detailsNode,
    dialogOpen,
    dropOffNode,
    onToggleDialog
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsxs(Dialog, {
    isOpen: !!dialogOpen,
    fullScreen: true,
    children: [jsx(DialogHeader, {
      showClose: true,
      closePosition: "left",
      onClose: onToggleDialog,
      css: getServiceCardDialogHeaderStyles,
      closeAriaLabel: t('service-card.dialog.close')
    }), jsx(DialogContent, {
      css: getServiceCardDialogContentStyles,
      children: jsxs(Fragment, {
        children: [dialogOpen === ServiceCardDialogType.DROPOFF && dropOffNode, dialogOpen === ServiceCardDialogType.DETAILS && detailsNode]
      })
    })]
  });
};

export { ServiceCardDialog, ServiceCardDialogType };
//# sourceMappingURL=ServiceCardDialog.js.map
